// extracted by mini-css-extract-plugin
module.exports = {"root":"SideBarTabs-module__root__fGew0"};